import React from "react";
import cn from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";
import { VariantSelector } from "~components";
import { useCartContext } from "~hooks";
import * as styles from "./styles.module.scss";

const CartUpsellWindowItem = ({
  product,
  quantity,
  setSelectedVariant,
  numberOfItemsInUpsellBundle
}) => {
  const { getCartDiscountPercentage, numberOfItemsInCart } = useCartContext();

  const numberOfItemsInCartIfTheseItemsWereAdded =
    numberOfItemsInCart + numberOfItemsInUpsellBundle * quantity;

  const discountPercentageIfTheseItemsWereAdded = getCartDiscountPercentage(
    numberOfItemsInCartIfTheseItemsWereAdded
  );

  const preDiscountPrice = product.price;
  const discountedPrice =
    preDiscountPrice -
    preDiscountPrice * (discountPercentageIfTheseItemsWereAdded / 100);

  return (
    <>
      <div className={styles.productDetails}>
        <div className={styles.flexContainer}>
          <div>
            <div className={styles.imageContainer}>
              {product?.image?.asset?.gatsbyImageData && (
                <GatsbyImage
                  image={product.image.asset.gatsbyImageData}
                  alt={product.title || ``}
                  style={{ position: `absolute`, inset: 0 }}
                />
              )}
            </div>
          </div>
          <div>
            <div className={cn(`h2`, styles.title)}>{product.title}</div>
            <div className={styles.price}>
              <span className="b1">${discountedPrice.toFixed(2)}</span>
              <span className={cn(`b1`, styles.strikethrough)}>
                ${preDiscountPrice.toFixed(2)}
              </span>
              <span className="caption">AUD</span>
            </div>
          </div>
        </div>
        <p className={cn(`b1`, styles.description)}>
          {product.shortDescription}
        </p>
      </div>
      <div className={styles.variantSelector} key={product.productId}>
        <VariantSelector
          bundleItem
          variants={product.variants}
          onChange={setSelectedVariant}
          quantity={quantity}
        />
      </div>
    </>
  );
};

export default CartUpsellWindowItem;
